export const Newsletter = {
	// Newsletter related Api calls

	newsletterSubscribe(params) {
		return this.service.post(
			'/api/newsletter-subscribe',
			params,
			response => Promise.resolve(response)
		)
	}
}
